import clsx from 'clsx';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useRef, useState } from 'react';
import { MdRefresh } from 'react-icons/md';
import { Modal, Button, Box } from '@mui/material';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import { accountsSlice } from 'app/store';
const { selectActiveUser } = accountsSlice;
import { linkDisplayStyles } from './styles';
import GenericModel from '../Models/GenericModel';
import ModelContainer from '../Models/ModelContainer';
import { overrideResetStyles } from '../Procedure/styles';
import { LinkPagination } from './components/LinkPagination';
import { SmeView } from 'GeminiViewerComponent/components/SmeView';
import { DisplayVideoContent } from './components/DisplayVideoContent';
import { LrsVerbs } from 'GeminiViewerComponent/features/xAPI/xApiData';
import { getConfig } from 'GeminiViewerComponent/features/config/configSlice';
import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { getActiveAssetActiveZone, selectActiveAsset } from 'GeminiViewerComponent/features/asset/assetSlice';
import { selectContentPanelItemlId } from 'GeminiViewerComponent/features/contentPanel/contentPanelItemSlice';
import { CompanionAppModes, LinkTypeIds, mapVideoContentURL, trackContentLinkViewed } from 'GeminiViewerComponent/helpers';
import { setCompanionApp } from 'GeminiViewerComponent/features/companionApps/companionAppsSlice';
import { getECTLToken, getECTLUrl, saveCompletion, saveStatement } from 'GeminiViewerComponent/features/xAPI/xapiSlice';
import {
    getLinkDisplayContent,
    getLinkDisplayData,
    getlLinkTypeId,
    getLinkDisplayVis,
    setLinkDisplayVis,
    getLinkVideoPlayback,
    getLinkOverlayText,
    getAllSimilarLinks,
    getUniqueContentLinks,
    getLinkAutoPlay,
    } from '../../features/globals/visibilitySlice';

const LinkDisplay = () => {
    const dispatch = useDispatch();
    const theme = useSelector(selectActiveTheme);
    const classes = linkDisplayStyles(theme);
    const overrideResetClasses = overrideResetStyles();
    var supposedCurrentTime = 0;
    const imageRef = useRef(null);
    const imageDivRef = useRef(null);
    const videoRef = useRef(null);

    const config = useSelector(getConfig);
    const linkDisplay = useSelector(getLinkDisplayVis);
    const linkContent = useSelector(getLinkDisplayContent);
    const linkData = useSelector(getLinkDisplayData);
    const linkTypeState = useSelector(getlLinkTypeId);
    const linkOverlayText = useSelector(getLinkOverlayText);
    const linkVideoPlayback = useSelector(getLinkVideoPlayback);
    const activeUser = useSelector(selectActiveUser);
    const activeAsset = useSelector(selectActiveAsset);
    const ectlURL = useSelector(getECTLUrl);
    const ectlToken = useSelector(getECTLToken);
    const allContentLinks = useSelector(getUniqueContentLinks);
    const linkAutoPlay = useSelector(getLinkAutoPlay);
    const TransformWrapperRef = useRef(null);

    const itemId = useSelector(selectContentPanelItemlId);
    const activeZone = useSelector(getActiveAssetActiveZone);
    const skillContent = linkTypeState === LinkTypeIds.Video && linkData?.skill_id;

    const [hideCloseButton, setHideCloseButton] = useState(false);
    const [currentActiveLinkIndex, setCurrentActiveLinkIndex] = useState(null);
    const lastTrackedLinkRef = useRef('');
    const [isChapterVideo, setIsChapterVideo] = useState({
        chapterPlayed: false,
        chapterCapture: false,
    });
    useEffect(() => {
        if (linkVideoPlayback?.requireVideoPlayback === true) {
            setHideCloseButton(linkVideoPlayback?.requireVideoPlayback === true);
        }

        if (linkDisplay) {
            dispatch(
                saveStatement({
                    LrsVerb: LrsVerbs.Launched,
                    itemId,
                    zoneId: activeZone?.zone_id,
                    response: {
                        ...{ action: 'linkDisplay' },
                        video: linkVideoPlayback,
                        content: linkContent,
                    },
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkVideoPlayback]);

    useEffect(() => {
        setIsMobileSafari(navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1);
        if (allContentLinks?.length > 0 && Object.keys(linkData).length > 0) {
            setCurrentActiveLinkIndex(allContentLinks.findIndex((link) => link.link_id === linkData?.link_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        dispatch(
            setLinkDisplayVis({
                open: false,
                linkContent: null,
                linkTypeId: null,
                linkData: null,
                autoPlay: false,
                overlayText: null,
            })
        );
    };

    const linkType = Number(linkTypeState);

    const handleLoadedMetadata = () => {
        const video = videoRef.current;
        if (!video) return;
        const videoDuration = video.duration;
        const watchFullVideo = linkVideoPlayback?.videoPlaybackEndMargin > videoDuration;
        let showButton = false;

        video.addEventListener('ended', function () {
            dispatch(
                saveStatement({
                    LrsVerb: LrsVerbs.Experienced,
                    itemId,
                    zoneId: activeZone?.zone_id,
                    response: {
                        ...{ watchFullVideo, videoDuration },
                        ...linkVideoPlayback,
                    },
                })
            );
        });

        if (linkVideoPlayback?.requireVideoPlayback === true || skillContent) {
            video.addEventListener('timeupdate', function () {
                if (!video.seeking) {
                    supposedCurrentTime = video.currentTime;
                    if (
                        !showButton &&
                        !watchFullVideo &&
                        linkVideoPlayback?.videoPlaybackEndMargin !== 0 &&
                        supposedCurrentTime >= linkVideoPlayback?.videoPlaybackEndMargin
                    ) {
                        showButton = true;
                        setHideCloseButton(false);
                    }
                }
            });
            video.addEventListener('seeking', function () {
                if (video.currentTime > supposedCurrentTime) {
                    // video.currentTime = supposedCurrentTime;
                }
            });
            video.addEventListener('ended', function () {
                showButton = true;
                setHideCloseButton(false);
                supposedCurrentTime = 0;
                if (skillContent && config.modeType === 'viewer') {
                    dispatch(
                        saveCompletion({
                            url: ectlURL,
                            api_token: ectlToken,
                            skill_id: skillContent,
                            // FIXME: remove static value once api side changes done
                            dod_id: activeUser?.dod_id || 'notavailable',
                            completion_time: moment(new Date()).format('YYYY-MM-DD'),
                        })
                    );
                } else {
                    dispatch(
                        saveStatement({
                            LrsVerb: LrsVerbs.Experienced,
                            response: {
                                ...{ watchFullVideo, videoDuration },
                                ...linkVideoPlayback,
                            },
                        })
                    );
                }
            });
        }
    };

    const [isMobileSafari, setIsMobileSafari] = useState(false);

    useEffect(() => {
        if (!linkDisplay || !linkContent) {
            return;
        }

        const isIframeDisplay = ![
            LinkTypeIds.Embed,
            LinkTypeIds.Image,
            LinkTypeIds.Video,
            LinkTypeIds.SME,
            LinkTypeIds.Model,
        ].includes(linkType);

        const trackingKey = `${linkData?.link_id ?? 'none'}:${String(linkContent)}:${linkType}:${isIframeDisplay}`;
        if (lastTrackedLinkRef.current === trackingKey) {
            return;
        }
        lastTrackedLinkRef.current = trackingKey;

        const contentType = isIframeDisplay
            ? 'pdf'
            : linkType === LinkTypeIds.Video
            ? 'video'
            : linkType === LinkTypeIds.Audio
            ? 'audio'
            : linkType === LinkTypeIds.Image
            ? 'image'
            : linkType === LinkTypeIds.Document
            ? 'document'
            : 'file';

        trackContentLinkViewed({
            contentType,
            srcPath: linkContent,
            assetId: activeAsset?.asset_id,
            assetName: activeAsset?.display_name,
        });
    }, [linkDisplay, linkContent, linkType, linkData?.link_id, activeAsset?.asset_id, activeAsset?.display_name]);

    if (linkType === LinkTypeIds.Document && isMobileSafari && linkDisplay) {
        window.open(linkContent, '_blank');
        handleClose();
    }

    const handleLinkNavigation = useCallback(
        (nodeIndex) => {
            const link = allContentLinks?.[nodeIndex];
            if (link && Object.keys(link).length > 0) {
                TransformWrapperRef.current?.resetTransform();
                TransformWrapperRef.current?.centerView(1);
                const linkContent = mapVideoContentURL(link);
                dispatch(
                    setLinkDisplayVis({
                        open: true,
                        chapter_data: link?.chapter,
                        allLinks: allContentLinks,
                        linkContent: linkContent,
                        linkData: {
                            ...link,
                            ...link?.content,
                            ...(typeof link.content_version === 'object' ? link.content_version : {}),
                            ...{ show_chapters: link?.show_chapters },
                        },
                        linkTypeId: link?.link_type_id || link?.link_type?.link_type_id,
                        autoPlay: Boolean(link?.auto_play),
                        overlayText: link.content_version?.overlay_text,
                    })
                );
            }
        },
        [allContentLinks, dispatch]
    );

    const handleKeyUp = useCallback(
        (e) => {
            if (e.key === 'ArrowLeft') {
                if (currentActiveLinkIndex - 1 >= 0) {
                    handleLinkNavigation(currentActiveLinkIndex - 1);
                }
            } else if (e.key === 'ArrowRight') {
                if (currentActiveLinkIndex + 1 < allContentLinks.length) {
                    handleLinkNavigation(currentActiveLinkIndex + 1);
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [currentActiveLinkIndex, allContentLinks]
    );

    const handleChangeDisplayOption = (companionAppModeId) => {
        handleClose();
        switch (companionAppModeId) {
            case CompanionAppModes.Right.id:
            case CompanionAppModes.Left.id:
            case CompanionAppModes.Top.id:
            case CompanionAppModes.Bottom.id:
                dispatch(
                    setCompanionApp({
                        display_name: linkData.display_name,
                        app_url: linkContent,
                        app_mode: companionAppModeId,
                        linkType,
                        linkData: linkData,
                        skill_id: null,
                    })
                );
                break;
            case CompanionAppModes.Window.id:
                window.open(linkContent, 'geminiContentWindow', 'popup');
                break;
            case CompanionAppModes.Tab.id:
                window.open(linkContent, '_blank');
                break;
        }
    };

    const hideLayoutPanel = activeAsset?.options?.hide_viewer_layout_panel;

    let displayOptions;
    switch (linkType) {
        case LinkTypeIds.SME:
            break;
        case LinkTypeIds.Model:
        case LinkTypeIds.Embed:
            displayOptions = [
                CompanionAppModes.Top,
                CompanionAppModes.Right,
                CompanionAppModes.Bottom,
                CompanionAppModes.Left,
            ];
            break;
        default:
            displayOptions = Object.values(CompanionAppModes);
            break;
    }

    // don't allow opening links without extensions
    if (displayOptions && !/\.\w+($|\?)/.test(linkContent)) {
        displayOptions = displayOptions.filter(
            (o) => o.id !== CompanionAppModes.Window.id && o.id !== CompanionAppModes.Tab.id
        );
    }

    // hide split-view layout options (Left/Right/Top/Bottom) when the asset's
    // Hide Layout Panel option is enabled; Tab and Window are unaffected
    if (hideLayoutPanel && displayOptions) {
        const splitViewIds = new Set([
            CompanionAppModes.Left.id,
            CompanionAppModes.Right.id,
            CompanionAppModes.Top.id,
            CompanionAppModes.Bottom.id,
        ]);
        displayOptions = displayOptions.filter((o) => !splitViewIds.has(o.id));
    }

    return (
        <div onKeyUp={handleKeyUp}>
            <Modal open={linkDisplay} onClose={linkVideoPlayback?.requireVideoPlayback ? null : handleClose}>
                <div
                    className={classes.modalContainer}
                    style={linkType === LinkTypeIds.Image || linkType === LinkTypeIds.Video ? { height: 'auto' } : {}}
                >
                    <LinkPagination
                        handleLinkNavigation={handleLinkNavigation}
                        currentActiveLinkIndex={currentActiveLinkIndex}
                        setCurrentActiveLinkIndex={setCurrentActiveLinkIndex}
                        displayOptions={displayOptions}
                        onChangeDisplayOption={handleChangeDisplayOption}
                    />
                    {linkType === LinkTypeIds.Embed ? (
                        <div
                            className={clsx(classes.embedContainer, overrideResetClasses.overrideMarzipanoResetCSS)}
                            dangerouslySetInnerHTML={{
                                __html: linkContent?.replace(
                                    /(<iframe[^>]+src=["'])([^"']+)(["'])/gi,
                                    (match, pre, src, post) => {
                                        try {
                                            const url = new URL(src);
                                            url.searchParams.delete('autoplay');
                                            url.searchParams.delete('mute');
                                            url.searchParams.delete('muted');
                                            if (linkAutoPlay) {
                                                url.searchParams.set('autoplay', '1');
                                                url.searchParams.set('mute', '1');
                                            }
                                            return `${pre}${url.toString()}${post}`;
                                        } catch {
                                            return match;
                                        }
                                    }
                                ),
                            }}
                        ></div>
                    ) : linkType === LinkTypeIds.Image ? (
                        <TransformWrapper
                            ref={TransformWrapperRef}
                            panning={{
                                velocityDisabled: true,
                                velocityAnimation: true,
                            }}
                            centerOnInit={true}
                            centerZoomedOut={true}
                            disablePadding={true}
                            pinch={{ step: 5 }}
                            wheel={{ smoothStep: 0.001, step: 0.2 }}
                            doubleClick={{ step: 0.7 }}
                        >
                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                <>
                                    <div className={classes.imageZoomButtons}>
                                        <div
                                            id="viewer_inline_reset-view-btn"
                                            className={classes.zoomButton}
                                            onClick={() => resetTransform()}
                                        >
                                            <MdRefresh />
                                        </div>
                                    </div>
                                    <TransformComponent>
                                        <img
                                            ref={imageRef}
                                            src={linkContent}
                                            alt={'LinkImage'}
                                            style={{
                                                objectFit: 'cover',
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                            }}
                                        />
                                    </TransformComponent>
                                    <div ref={imageDivRef}>
                                        {linkOverlayText?.html && (
                                            <div
                                                className={clsx(
                                                    classes.overlayText,
                                                    overrideResetClasses.overrideMarzipanoResetCSS
                                                )}
                                                dangerouslySetInnerHTML={{
                                                    __html: linkOverlayText?.html,
                                                }}
                                            ></div>
                                        )}
                                    </div>
                                </>
                            )}
                        </TransformWrapper>
                    ) : linkType === LinkTypeIds.Video ? (
                        <DisplayVideoContent
                            handleLoadedMetadata={handleLoadedMetadata}
                            isChapterVideo={isChapterVideo}
                            setIsChapterVideo={setIsChapterVideo}
                            videoRef={videoRef}
                        />
                    ) : linkType === LinkTypeIds.SME ? (
                        <SmeView
                            sme={{
                                ...linkData,
                                ...{ url: linkContent },
                            }}
                        />
                    ) : linkType === LinkTypeIds.Model ? (
                        <ModelContainer Model={GenericModel} modelURL={linkContent} />
                    ) : (
                        <Box component="iframe" src={linkContent} width="100%" height="100%" title="content" />
                    )}
                    {!hideCloseButton && (
                        <Button
                            id="viewer_inline_close-btn"
                            className={classes.close}
                            onClick={handleClose}
                            variant="contained"
                            disableElevation
                        >
                            Close
                        </Button>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export { LinkDisplay };
